import type {ReactElement} from 'react';
import React from 'react';
import type {RGBA} from '@Utils/color.util';
import {getFillTypeFromColorFillType} from '@Utils/color.util';
import type {ColorFillPropertyType} from '@Components/color-fill';
import {BaseListColorPanel} from '@Components/poster-editor/components/poster-editing-side-panel/components/base-list-color-panel';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';
import {useGetKeyFromListOfActiveItem} from '@Hooks/poster-editor/useGetKeyFromListOfActiveItem';
import {useGetKeyFromFillOfListOfActiveItem} from '@Hooks/poster-editor/useGetKeyFromFillOfListOfActiveItem';

export function TextItemListColorPanel(): ReactElement<any> {
  const activeItemId = useSingleActivePosterItemId() ?? '';
  const activeItem = activeItemId ? window.posterEditor?.whiteboard?.getItemForId(activeItemId) : undefined;
  const listType = useGetKeyFromListOfActiveItem('type');
  const listStyle = useGetKeyFromListOfActiveItem('style');
  const listWidth = useGetKeyFromListOfActiveItem('width');
  const listFillType = useGetKeyFromFillOfListOfActiveItem('fillType');
  const listFillColor = useGetKeyFromFillOfListOfActiveItem('fillColor');

  if (
    !activeItem ||
    (activeItem && !('list' in activeItem)) ||
    !listFillColor ||
    listFillType === undefined ||
    listType === undefined ||
    listWidth === undefined ||
    listStyle === undefined
  ) {
    throw new Error("item doesn't have list property");
  }

  const updateFillColor = (fillColor: RGBA[], undoable = true): void => {
    void activeItem.updateFromObject(
      {
        list: {
          fill: {
            fillColor,
          },
        },
      },
      {
        undoable,
      }
    );
  };

  const onChangeType = (newType: ColorFillPropertyType): void => {
    void activeItem.updateFromObject({
      list: {
        fill: {
          fillType: getFillTypeFromColorFillType(newType),
          fillColor: activeItem.list.fill.getColorForNewType(getFillTypeFromColorFillType(newType)),
        },
      },
    });
  };

  return (
    <BaseListColorPanel
      list={{
        type: listType,
        style: listStyle,
        width: listWidth,
        fill: {
          fillColor: listFillColor,
          fillType: listFillType,
        },
      }}
      updateFillColor={updateFillColor}
      onChangeType={onChangeType}
    />
  );
}
